import React from 'react'
import Header from '../Header/Header'

export default function TemporaryITStaffing() {
  return (
   <>
    <Header isActive={"Services"}/>
    <div id="content" class="site-content">
        <div className="page-header dtable text-center" style={{ backgroundImage: 'url(resources/images/banner-.jpg)' }}>
   <div className="dcell">
      <div className="container">
         <h1 className="page-title">Temporary IT Staffing</h1>
      </div>
   </div>
</div>
<section className="p-b0">
   <div className="container">
      <div className="flex-row">
         <div className="services-left-1">
            <img src="resources/images/image-banner-home6.png" alt="" />
         </div>
         <div className="services-right-1 align-self-center">
            <div className="ot-heading">
               <h6><span>Temporary IT Staffing</span></h6>
               <h2 className="main-heading">Flexible Staffing with Humanix Technologies</h2>
            </div>
            <p className="m-b50">At Humanix Technologies, we offer IT consulting services focused on temporary staffing solutions to address your immediate project needs, craft a technology-driven digital strategy, and optimize your software portfolio. Our expert software engineers provide skilled, flexible talent, ensuring seamless integration and support for your short-term goals and dynamic requirements.</p>
            <div className="row">
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="100" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Active Developers</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40 xs-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="30" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Satisfied Clients</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="50" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Innovative Solutions Delivered</h6>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>What You Will Gain</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span>
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Skilled Developers On-Demand</h5>
                  <p>Access a pool of highly skilled developers proficient in cutting-edge technologies to meet your temporary IT staffing needs.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span>
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Flexible Staffing Solutions</h5>
                  <p>Hire developers with expertise in creating custom applications, scalable software, and business-driven IT solutions for short-term projects.</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span>
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Seamless Team Integration</h5>
                  <p>Bring on developers who can integrate effortlessly with your in-house teams, ensuring smooth collaboration and immediate productivity.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span>
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Quickly Scalable Workforce</h5>
                  <p>Rapidly scale your IT team to meet project deadlines and adapt to changing business demands with ease and flexibility.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
{/* <section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>Key offerings of the program</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span>
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Career Mentorship</h5>
                  <p>Personalised career mentoring to help you prepare and build your profile</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span>
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Doubt Solving Sessions</h5>
                  <p>Advance doubt resolution sessions by expert teaching assistants</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span>
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Mock Interviews</h5>
                  <p>Mock interviews to help you prepare for your job interviews</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span>
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Capstone Projects</h5>
                  <p>Industry-relevant projects to build your portfolio and get you job-ready</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t100 p-b50">
   <div className="container">
      <div className="row">
         <h1>Curriculum</h1>
         <div className="col-md-6 col-xs-12 sm-m-b40">
            <div className="ot-accordions">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -1<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Introduction to Data Science</h6>
                     <div className="row">
                        <div className="col-xs-4">6 Weeks</div>
                        <div className="col-xs-4">1 Guest Lecture</div>
                        <div className="col-xs-4">2 Contests</div>
                     </div>
                     This module will help beginners to get familiar with Data Science, Calculus, and Algebra
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -2 <i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Statistics and Probability Excel and SQL</h6>
                     <div className="row">
                        <div className="col-xs-6">3 Modules</div>
                        <div className="col-xs-6">2 Months</div>
                     </div>
                     <p>Learn basics of Data Science including distributions, probability, discrete random variables, and many more. You will also gain a deep understanding of Excel and Google Sheets. Learn to use SQL to extract and analyze...</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -3<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Learn Programming</h6>
                     <div className="row">
                        <div className="col-xs-6">5 Modules</div>
                        <div className="col-xs-6">3 Months</div>
                     </div>
                     <p>Start learning Python from a very basic level. Develop an understanding of how Python helps in exploratory data analysis, and then advance Python using the framework. Also, learn how to work with data and automate processes that will make you an efficient data scientist.</p>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-xs-12">
            <div className="ot-accordions accordions-gradient">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -4<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Machine Learning</h6>
                     <div className="row">
                        <div className="col-xs-6">8 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>In this module, you will learn the importance of machine learning and its major components. We will begin with an introduction to machine learning and move on to its applications, supervised vs unsupervised learning, and stages of the ML project.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -5<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Cloud Computing, NLP and Data Mining</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>In this module, you will learn to work on expanding computing power and deploying data solutions in a much easier fashion. Traditional IT infrastructure vs. cloud infrastructure, an overview of cloud segments, an overview of cloud security, etc. You will also learn how to fetch information from the unstructured or semi-structured text.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -6<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Interview Practice</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Get prepared for your interviews by solving various real-life case studies, business problems, and guesstimate-type questions. Get ready to ace the Interviews.</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
<section className="p-t120 p-b50 bg-pricing">
   <div className="container">
      <div className="ot-heading text-center">
         <h2 className="main-heading">Pricing Details</h2>
      </div>
      <div className="row">
         <div className="col-md-4 sm-p-b60">
         </div>
         <div className="col-md-4 sm-p-b60">
            <div className="ot-pricing-table bg-shape s2">
               <span className="title-table">10% Discount</span> 
               <div className="inner-table sm-p-t60">
                  <img src="resources/images/price2-1.png" alt="Economy" />
                  <h6><s><sup>₹</sup> 75000</s></h6>
                  <h2><sup>₹</sup> 67500</h2>
                  <div className="details">
                     <ul>
                        <li>Course Duration 9 Months</li>
                        <li>40L Highest salary offered</li>
                        <li>10L Average CTC offered</li>
                        <li>9 Days Placement time</li>
                        <li>Upto 350% Salary hike</li>
                     </ul>
                  </div>
               </div>
               <a href="contact.html" className="octf-btn octf-btn-icon octf-btn-third">ENROLL NOW <i className="flaticon-right-arrow-1"></i></a> 
            </div>
         </div>
         <div className="col-md-4">
         </div>
      </div>
   </div>
</section> */}

<section className="container">
   <div className="p-t120">
      <div className="row flex-row align-items-end">
         <div className="col-lg-6 col-md-12 col-xs-12 xs-m-b40">
            <div className="ot-heading">
               <h2 className="main-heading">Here to Help Your Every Business Need</h2>
            </div>
            <div className="ot-accordions">
               <div className="acc-item current">
                  <div className="acc-content active" style={{ display: 'block' }}>
We specialize in providing temporary staffing solutions, allowing you to focus on growing your business.
Let us handle your short-term staffing needs while you concentrate on what matters most.
Explore how our skilled developers can seamlessly integrate into your team and deliver immediate results.
Partner with us to unlock the full potential of your projects through expert, flexible staffing solutions.
We’re here to provide the talent you need, ensuring your business stays agile and productive.
Discover how our temporary staffing solutions can boost your team—start today!</div>
               </div>
            </div>
         </div>
         <div className="col-lg-6 col-md-12 col-xs-12 text-center">
            <img src="resources/images/img.png" alt="seo" />
         </div>
      </div>
   </div>
</section>

{/* <section className="p-b50">
   <div className="container">
      <div className="row">
         <div className="col-md-12">
            <div className="partners">
               <div className="owl-carousel home-client-carousel">
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/zoomcar-4.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/zoomcar-10.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/zoomcar-8.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/zoomcar-6.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/zoomcar-17.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/cred.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/meeso.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/paytm.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/upgrad.webp" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/rakuten.png" alt="" /> </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner"> <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" /> </figure>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section> */}

    </div>
    </>
  )
}
